import React, { useState, useEffect, useRef } from 'react';
import { Box, Grid, TextField, Button, FormControlLabel, Checkbox, Tooltip, Select, MenuItem, ListItemText } from '@mui/material';
import axios from '../../utils/fvAxios';
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import {
  setToken, setEmail, setUserName, setGlobalClientId, setstatuses, setOrgType, setLocalMenus, removeIncognitoEmail, setOrgId, setisEmp, getisEmp, getExpiredSec,
  getInvitationURL, getInvitationVendorId, getInvitationClientId, getInvitationIsMultiClient, getInvitationPqid, setOnSiteOffsiteDetails, setOnSiteOffsiteId, setExpiredSec,
  setMoodleUserId, removeUserSession,
  getToken
} from "../../utils/Token";
import apiinfo from "../../utils/base-uri.json";
import BaseUrl from "../../utils/base-uri.json";


export default function EmployeeVendorSelfRegistration() {
  const [name, setName] = useState('');
  const [lastname, setLastName] = useState('');
  const [Email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [checked, setChecked] = useState(false);

  const [EmailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [loader, Setloader] = React.useState(false);
  const [Data, setData] = React.useState({});



  const params = new URLSearchParams(window?.location?.search);
  const vendorCode = params?.get("VendorCode");
  const navigate = useNavigate();

  useEffect(() => {
    axios.get("Common/EmployeeSelfRegistration?vendorCode=" + vendorCode
    ).then((respn) => {
      if (respn?.data?.responseCode === 100) {
        setData(respn?.data?.data)
      }
    }).catch(err => {
      console?.log(err)
    })

  }, [])

  const handleclose = () => {
    setName('');
    setLastName('');
    setEmail('');
    setPassword('');
    setConfirmPassword('');
    setChecked(false);
    setEmailError('')
    setConfirmPasswordError('');
  }
  const Exit = () => {
    removeUserSession();
    window.location = "/login";
  }

  const handleNameChange = (event) => {
    setName(event?.target?.value);
  };
  const handleLastNameChange = (event) => {
    setLastName(event?.target?.value);
  };

  const handleInputChange = (event) => {
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,20}$/;
    const phoneRegex = /^[0-9]{10}$/;
    if (event?.target?.value == "") {
      setEmail(event?.target?.value);
      setEmailError("");
    } else if (emailRegex?.test(event?.target?.value) || phoneRegex?.test(event?.target?.value)) {
      setEmail(event?.target?.value);
      setEmailError("");
    } else {
      setEmail(event?.target?.value);
      setEmailError('Please enter a valid email address or phone number');
    }
  };

  const handlePasswordChange = (event) => {
    setConfirmPassword("");
    const Phoneregex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{10,}$/;
    if (event?.target?.value == "") {
      setPassword(event?.target?.value);
      setPasswordError('');
    } else if (!Phoneregex?.test(event?.target?.value)) {
      setPassword(event?.target?.value);
      setPasswordError('Minimum 10 characters, at least one upper case letter, one lower case letter, one number and one special character');
    } else {
      setPassword(event?.target?.value);
      setPasswordError('');
    }
  };

  const handleConfirmPasswordChange = (event) => {
    if (password == event?.target?.value) {
      setConfirmPassword(event?.target?.value);
      setConfirmPasswordError('');
    } else {
      setConfirmPassword(event?.target?.value);
      setConfirmPasswordError("Password does not match");
    }
  };
  const handleChange = (event) => {
    setChecked(event?.target?.checked);
  };

  const handleSubmit = () => {

    if (name != "" && lastname != "" && Email != "" && password != "" && confirmPassword != "" && checked == true && EmailError == "" && confirmPasswordError == "" && passwordError == "") {
      Setloader(true);
      const location = {
        "firstName": name,
        "lastName": lastname,
        "mobileNumber": Email,
        "password": password,
        "vendorCode": vendorCode
      };

      const details = {
        "userName": Email,
        "password": password
      }

      axios.post("Common/EmployeeSelfRegistrationVendor", location).then((res) => {
        if (res?.data?.responseMessage == "Success") {
          toast.success(res?.data?.data, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          removeUserSession();

          axios
            .post(BaseUrl.login.loginRequest, details)
            .then((response) => {
              if (response?.data?.responseCode >= 0) {
                setExpiredSec("0");
                removeIncognitoEmail();
                setToken(response?.data?.data?.token);
                setUserName(response?.data?.data?.userName);
                setEmail(response?.data?.data?.email);
                setGlobalClientId(response?.data?.data?.globalClientId);
                setOrgId(response?.data?.data?.orgId);
                setOrgType(response?.data?.data?.orgType);
                setLocalMenus(response?.data?.data?.userMenus);
                setisEmp(response?.data?.data?.isEmployee);
                setMoodleUserId(response?.data?.data?.moodleUserId);
                axios.get(apiinfo.dashboard.GetprequalificationStatuses)
                  .then((res) => {
                    if (res?.data?.status === true) {
                      setstatuses(res?.data?.data);
                    } else {
                      alert(res.data.responseMessage);
                    }
                  })
                const URL = getInvitationURL();
                const VendorId = getInvitationVendorId();
                const CLIENTID = getInvitationClientId();
                const ISMultiClient = getInvitationIsMultiClient();
                const InvitationPqid = getInvitationPqid();

                const allowedPath = ["/registration-company"];
                const PageName = (!URL || URL == "null" || URL == "/login?registered=success") ? (!(response?.data?.data?.isEmployee) || response?.data?.data?.isEmployee == false ? "/DashBoard" : "/EmployeeSignature") : ((URL && VendorId != 'null' && URL?.indexOf(allowedPath) !== -1) ? "/DashBoard" : (URL == "/TemplatesList" ? (URL + "?InvitationClient=" + CLIENTID + "&InvitationVendor=" + VendorId + "&InvitationIsMultiClient=" + ISMultiClient + "&pqid=" + InvitationPqid) : URL));
                navigate(PageName);
                Setloader(false);

                const channel = new BroadcastChannel('refresh_channel');
                channel.postMessage('refresh1');

              } else {
                toast.error(response.data.responseMessage, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              }
            });

          handleclose();
          setTimeout(() => {
            Setloader(false);
          }, 5000)

        } else {
          toast.error(res?.data?.data, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          handleclose();
          setTimeout(() => {
            Setloader(false);
          }, 5000)
        }
      })

    } else {
      Setloader(false);
      toast.error("Please fill out the mandatory fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

    }
  };

  return (
    <>
      <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <p style={{ color: "#0C8AEB", fontSize: "18px", fontWeight: 500, cursor: "pointer" }} onClick={Exit}>{"<--Back to login"}</p>
      <Grid container spacing={2}>
        <Grid item xs={2} md={1}>
        </Grid>
        <Grid item xs={12} md={10}>
          <div style={{ padding: "10px" }}>
            <b className="mt-3" style={{ fontSize: "24px" }}>Employee Registration</b>

            <Box
              border={1}
              borderLeft={1}
              borderRight={1}
              borderColor="#e4e7ec"
              className="mt-3"
              sx={{ background: '#fff', padding: "20px" }}
            >
              <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: '20px' }}>

                <Grid item xs={12} sm={6} md={6}>
                  <p style={{ color: '#3E4A62', fontSize: '20px', fontWeight: '500', marginBottom: 0 }}>Company : </p>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <span style={{ fontWeight: 'bold', fontSize: '20px', }}>{Data?.companyName}</span>
                </Grid>

                {/* First Name */}
                <Grid item xs={12} sm={6} md={6}>
                  <p style={{ color: '#3E4A62', fontSize: '20px', fontWeight: '500', marginBottom: 0 }}>First Name <span style={{ color: "red" }}>*</span></p>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    fullWidth
                    name="firstName"
                    size="small"
                    value={name}
                    onChange={handleNameChange}
                  />
                </Grid>

                {/* Last Name */}
                <Grid item xs={12} sm={6} md={6}>
                  <p style={{ color: '#3E4A62', fontSize: '20px', fontWeight: '500', marginBottom: 0 }}>Last Name <span style={{ color: "red" }}>*</span></p>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    fullWidth
                    name="lastName"
                    size="small"
                    value={lastname}
                    onChange={handleLastNameChange}
                  />
                </Grid>

                {/* Email */}
                <Grid item xs={12} sm={6} md={6}>
                  <p style={{ color: '#3E4A62', fontSize: '20px', fontWeight: '500', marginBottom: 0 }}>User ID (Email Address or Mobile no) <span style={{ color: "red" }}>*</span></p>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    fullWidth
                    name="Email"
                    size="small"
                    value={Email}
                    onChange={handleInputChange}
                    error={!!EmailError}
                    helperText={EmailError}
                  />
                </Grid>

                {/* Password */}
                <Grid item xs={12} sm={6} md={6}>
                  <p style={{ color: '#3E4A62', fontSize: '20px', fontWeight: '500', marginBottom: 0 }}>Password <span style={{ color: "red" }}>*</span></p>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Tooltip
                    placement="left-start"
                    title={
                      <div >
                        <h6><div class='controlHintText'>Your password must meet the following requirements:<br />At least 10 characters long<br />Contain at least 1 uppercase letter<br />Contain at least 1 lowercase letter<br />Contain at least 1 number <br />Contain at least 1 special character</div></h6>
                      </div>
                    }
                    arrow
                  >
                    <TextField
                      fullWidth
                      type="password"
                      size="small"
                      value={password}
                      onChange={handlePasswordChange}
                      error={!!passwordError}
                      helperText={passwordError}
                    />
                  </Tooltip>
                </Grid>

                {/* Confirm Password */}
                <Grid item xs={12} sm={6} md={6}>
                  <p style={{ color: '#3E4A62', fontSize: '20px', fontWeight: '500', marginBottom: 0 }}>Confirm Password <span style={{ color: "red" }}>*</span></p>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    fullWidth
                    type="password"
                    size="small"
                    value={confirmPassword}
                    onChange={handleConfirmPasswordChange}
                    error={!!confirmPasswordError}
                    helperText={confirmPasswordError}
                  />
                </Grid>





                {/* Agreement */}



              </Grid>
              <br />
              <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: '10px' }}>
                <Grid item xs={12} sm={6} md={6}>
                  Please accept the  <a href="/terms_and_conditions" target="_blank" rel="noopener noreferrer">Terms and Conditions.</a> You must check the box below to confirm you agree to the Terms and Conditions:
                  <br />
                  <br />
                  <FormControlLabel
                    className='mx-1'
                    control={<Checkbox color="primary" name="agreement" checked={checked} onChange={handleChange} />}
                    label={<span><span className='mr-1' style={{ color: "red" }}>*</span>I agree to the <b>FIRST, VERIFY</b> Terms and Conditions.</span>}
                  />


                </Grid>   </Grid>
              <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: '10px' }}>
                <Grid item xs={6} sm={6} md={6}>
                  <Button className="login-button-request" variant="contained" sx={{ padding: "20px" }} onClick={handleSubmit}>Create Account</Button>
                </Grid>
                <Grid item xs={6} sm={6} md={6} sx={{ float: "right" }}>
                  <Button variant="contained" className="login-help-button-cancel" sx={{ padding: "20px", float: "right" }} onClick={handleclose}>Cancel</Button>
                </Grid>
              </Grid>

            </Box>

          </div>
        </Grid>
        <Grid item xs={2} md={1}>
        </Grid> </Grid>
    </>
  );
}
